const PREVIEW_ACCESS_TOKEN_KEY = "purissima.anamnese.preview_token";
const PREVIEW_PROFILE_KEY = "purissima.anamnese.preview_profile";
const PREVIEW_QUESTIONNAIRE_SLUG_KEY = "purissima.anamnese.preview_questionnaire_slug";

export const getPreviewAccessToken = () => {
  try {
    return sessionStorage.getItem(PREVIEW_ACCESS_TOKEN_KEY);
  } catch {
    return null;
  }
};

export const setPreviewAccessToken = (token) => {
  try {
    if (token) {
      sessionStorage.setItem(PREVIEW_ACCESS_TOKEN_KEY, token);
    }
  } catch {}
};

export const clearPreviewAccessToken = () => {
  try {
    sessionStorage.removeItem(PREVIEW_ACCESS_TOKEN_KEY);
    sessionStorage.removeItem(PREVIEW_PROFILE_KEY);
    sessionStorage.removeItem(PREVIEW_QUESTIONNAIRE_SLUG_KEY);
  } catch {}
};

export const getPreviewProfile = () => {
  try {
    const raw = sessionStorage.getItem(PREVIEW_PROFILE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
};

export const setPreviewProfile = (profile) => {
  try {
    if (profile && typeof profile === "object") {
      sessionStorage.setItem(PREVIEW_PROFILE_KEY, JSON.stringify(profile));
    } else {
      sessionStorage.removeItem(PREVIEW_PROFILE_KEY);
    }
  } catch {}
};

export const getPreviewQuestionnaireSlug = () => {
  try {
    const slug = sessionStorage.getItem(PREVIEW_QUESTIONNAIRE_SLUG_KEY);
    return slug && String(slug).trim() !== "" ? String(slug).trim() : null;
  } catch {
    return null;
  }
};

export const setPreviewQuestionnaireSlug = (slug) => {
  try {
    if (slug && String(slug).trim() !== "") {
      sessionStorage.setItem(PREVIEW_QUESTIONNAIRE_SLUG_KEY, String(slug).trim());
    } else {
      sessionStorage.removeItem(PREVIEW_QUESTIONNAIRE_SLUG_KEY);
    }
  } catch {}
};

export const hasPreviewSession = () => Boolean(getPreviewAccessToken());

export const isAnamneseV2Path = (pathname) =>
  String(pathname || "").startsWith("/anamnese-v2");

export const hasExplicitPreviewMarker = (location) => {
  const params = new URLSearchParams(location?.search || "");

  return Boolean(
    params.get("preview_token") ||
      params.get("is_preview") === "1" ||
      location?.state?.isPreview,
  );
};

/**
 * Preview só vale dentro de /anamnese-v2 e com marcador na URL/state.
 * Token no sessionStorage sozinho não libera o resto do site.
 */
export const isAnamnesePreviewNavigation = (location) =>
  isAnamneseV2Path(location?.pathname) && hasExplicitPreviewMarker(location);

export const withPreviewQuery = (path, isPreview) => {
  if (!isPreview || String(path).includes("is_preview=")) {
    return path;
  }

  return `${path}${String(path).includes("?") ? "&" : "?"}is_preview=1`;
};
